import template from './ecocode-trustpilot-additional-settings.html.twig';
const {Component} = Shopware;

Component.register('ecocode-trustpilot-additional-settings', {
    template,
    inject: ['ecocodeTrustpilotConfigurationService'],
    data() {
        return {
            showConfirmModal: false,
        };
    },
    async mounted() {
    },
    methods: {
        openConfirmModal() {
            this.showConfirmModal = true;
        },
        onConfirm() {
            this.showConfirmModal = false;
            this.clearAuthenticationToken();
        },
        onClose() {
            this.showConfirmModal = false;
        },
        async clearAuthenticationToken() {
            await this.ecocodeTrustpilotConfigurationService.disconnect();
            this.$router.replace({name: 'ecocode.trustpilot.setup.connect'});
        }
    }
});
